import React from "react";
import { AlertTriangle } from "lucide-react";

const CloseCashBookModal = ({ open, onClose, onConfirm }) => {

    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

            <div className="bg-white rounded-2xl shadow-2xl w-[420px] p-6 animate-scaleIn">

                <div className="flex items-center gap-3 mb-4">
                    <div className="bg-red-100 text-red-600 p-3 rounded-full flex items-center justify-center shadow-sm">
                        <AlertTriangle size={22} strokeWidth={2.5} />
                    </div>
                    <h2 className="text-lg font-semibold text-gray-800">
                        Close CashBook?
                    </h2>
                </div>

                <p className="text-sm text-gray-600 mb-6">
                    Are you sure you want to request closing this CashBook?
                    <br />
                    <span className="text-red-500 font-medium">
                        Requires admin approval
                    </span>
                </p>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                    >
                        Submit Request
                    </button>
                </div>

            </div>
        </div>
    );
};

export default CloseCashBookModal;